import router from '../router'
import * as common from '../api/common'
import * as api from '../api/api'
import { Toast, Dialog } from 'vant'

export const checkPassword = (password) => {
  if (!password) {
    return false
  }
  const regex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{6,16}$/
  return regex.test(password)
}

export const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

export const formatTimeMDChinese = date => {
  const month = date.getMonth() + 1
  const day = date.getDate()

  return formatNumber(month) + '月' + formatNumber(day) + '日'
}

export const formatTimeYMDInterval = (date, interval = '-') => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return formatNumber(year) + interval + formatNumber(month) + interval + formatNumber(day)
}
export const formatTimeHourMinutes = (date) => {
  const hour = date.getHours()
  const minute = date.getMinutes()

  return [hour, minute].map(formatNumber).join(':')
}

export const formatTimeInterval = (date, yearInterval, hourInterval) => {
  date = new Date(date)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  return [year, month, day].map(formatNumber).join(yearInterval) + ' ' + [hour, minute, second].map(formatNumber).join(hourInterval)
}

export const isTeacher = () => {
  const userInfo = localStorage.getItem(common.keyUserInfo)
  if (userInfo) {
    const userInfos = JSON.parse(userInfo)
    return userInfos.member_type === 4
  } else {
    return false
  }
}

// 检查客户端
export const judgeClient = () => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // 判断是否是 android终端
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 判断是否是 iOS终端

  if (isAndroid) {
    return 'Android'
  } else if (isIOS) {
    return 'IOS'
  } else {
    return 'PC'
  }
}

export const formatZHYMDHM = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  // const second = date.getSeconds()
  return year + '年' + month + '月' + day + '日' + ' ' + [hour, minute].map(formatNumber).join(':')
}

export const formatTimeYMDChinese = date => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return formatNumber(year) + '年' + formatNumber(month) + '月' + formatNumber(day) + '日'
}

// 获取相对路径
export const GetUrlRelativePath = (val) => {
  // var url = document.location.toString()
  var url = val.toString()
  var arrUrl = url.split('//')
  var start = arrUrl[1].indexOf('/')
  var relUrl = arrUrl[1].substring(start)// stop省略，截取从start开始到结尾的所有字符
  if (relUrl.indexOf('?') !== -1) {
    relUrl = relUrl.split('?')[0]
  }
  return relUrl
}

export const GetQueryString = (name, imgUrl) => {
  var url = imgUrl.toString()
  var arrObj = url.split('?')
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split('&')
    var arr
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')
      if (arr != null && arr[0] === name) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}

export const getFiveTimeOut = (str) => {
  // const str = 1696928195861
  //  const str = Date.now()
  // var now = Date.now()
  const nowStr = new Date().getTime()

  if (nowStr > (str + 5 * 60 * 1000) || str > (nowStr + 5 * 60 * 1000)) {
    console.log(' 超过了5分钟')
    return false
  } else {
    console.log(' 没有超过5分钟')
    return true
  }
}
// 更新配置数据
export const refreshConfigData = (week, d) => {
  const configData = JSON.parse(localStorage.getItem(common.keyConfigInfo))

  let allData = {}
  if (d === undefined) {
    allData = configData
  } else {
    allData = d
  }

  const data = JSON.parse(JSON.stringify(allData))

  if (data && Array.isArray(data.piano_open_time)) {
    const currentWeek = typeof week === 'number' ? week : new Date().getDay()
    const pt = data.piano_open_time
    let exist = false
    if (pt.length === 1 && Array.isArray(pt[0].weeks) && pt[0].weeks.length === 0) {
      // 全周
      configData.begin_time = pt[0].startTime
      configData.end_time = pt[0].endTime
      exist = true
    } else {
      for (let i = 0; i < pt.length; i++) {
        if (Array.isArray(pt[i].weeks) && pt[i].weeks.includes(currentWeek)) {
          configData.begin_time = pt[i].startTime
          configData.end_time = pt[i].endTime
          exist = true
          break
        }
      }
    }

    if (!exist) {
      configData.begin_time = '00:00'
      configData.end_time = '00:01'
    }
  }
  return configData
}

// 判断返回信息
export const judgeBackMsg = (res) => {
  if (res === undefined) {
    return
  }
  let normalTip = ''
  if (res) {
    if (res.code === common.resCode.Failed) {
      Toast.fail(res.msg)
    } else if (res.code === common.resCode.ResourceNotbeFound) {
      Dialog.alert({
        title: '提示',
        message: '数据加载失败，点击确定后返回上一页'
      }).then(() => {
        // on close
        router.go(-1)
      })
    } else {
      normalTip = common.resMSG[res.code] === undefined ? res.msg : common.resMSG[res.code]
      Toast.fail((normalTip !== undefined && normalTip !== null) ? normalTip : '数据加载失败，请稍后重试')
    }
  } else {
    Toast.fail('请求出错')
  }
}

export const judgeTodayWhatDay = (val) => {
  switch (val) {
    case 0:
      return '周日'
    case 1:
      return '周一'
    case 2:
      return '周二'
    case 3:
      return '周三'
    case 4:
      return '周四'
    case 5:
      return '周五'
    case 6:
      return '周六'
  }
}
export const formatDate = function (dateStr) {
  if (!dateStr) {
    return ''
  }

  if (/^\d{2,4}(-|\/)\d{1,2}(-|\/)\d{1,2}/.test(dateStr)) {
    let gmtTime
    if (/^\d{2,4}-\d{1,2}-\d{1,2}/.test(dateStr)) {
      gmtTime = /\.\d+Z$/.test(dateStr)
      dateStr = dateStr.replace(/-/g, '/').replace(/T/, ' ').replace(/\.\d+Z$/, '').replace(/\.\d+\+/, '+')
        .replace(/\+\d{2}:\d{2}$/, '')
    }

    const date = new Date(dateStr)
    if (gmtTime && date) {
      date.setMinutes(date.getMinutes() - new Date().getTimezoneOffset())
    }
    return date
  } else {
    return ''
  }
}

export const getTimeQuantum = function (timeQuantum, bookInterval, filterStartMinutes, filterEndMinutes) {
  if (!Array.isArray(timeQuantum)) {
    return []
  }
  if (!bookInterval) {
    bookInterval = 0
  }
  let spanTimeList = []
  try {
    const tempList = []
    for (let i = 0; i < timeQuantum.length; i++) {
      const item = timeQuantum[i].split('-')
      const start = item[0].split(':')
      const end = item[1].split(':')
      const startTotalMinutes = parseInt(start[0]) * 60 + parseInt(start[1])
      const endTotalMinutes = parseInt(end[0]) * 60 + parseInt(end[1])
      if (i > 0) {
        if (startTotalMinutes - tempList[i - 1].endTotalMinutes > bookInterval) {
          // 添加一个不可用的时间
          spanTimeList.push({
            showTime: tempList[i - 1].endTime + '-' + item[0],
            startTime: tempList[i - 1].endTime,
            endTime: item[0],
            startTotalMinutes: tempList[i - 1].endTotalMinutes,
            endTotalMinutes: startTotalMinutes,
            bookTotal: 10000, // 预约次数
            overdueCur: true, // 是否被占用 当使用和容量相等时为true或者已过期
            continuousCur: false, // 相对于被选中的时间段是否是可选的
            fill: true // 填充
          })
        }
      }
      const ob = {
        showTime: timeQuantum[i],
        startTime: item[0],
        endTime: item[1],
        startTotalMinutes: startTotalMinutes,
        endTotalMinutes: endTotalMinutes,
        bookTotal: 0, // 预约次数
        overdueCur: false, // 是否被占用 当使用和容量相等时为true或者已过期
        continuousCur: false // 相对于被选中的时间段是否是可选的
      }
      spanTimeList.push(ob)
      tempList.push(ob)
    }
  } catch (e) {
    console.log(e)
    spanTimeList = []
  }
  if (spanTimeList.length && typeof filterStartMinutes === 'number' && typeof filterEndMinutes === 'number') {
    const newList = []
    for (let i = 0; i < spanTimeList.length; i++) {
      // 找出与过滤时间有重叠的时间段落
      if (spanTimeList[i].startTotalMinutes < filterEndMinutes && spanTimeList[i].endTotalMinutes > filterStartMinutes) {
        newList.push(spanTimeList[i])
      }
    }
    return newList
  } else {
    return spanTimeList
  }
}

export const filterTimeQuantum = function (spanTimeList, filterStartMinutes, filterEndMinutes) {
  if (!Array.isArray(spanTimeList)) {
    return []
  }
  const newList = []
  for (let i = 0; i < spanTimeList.length; i++) {
    // 找出与过滤时间有重叠的时间段落
    if (spanTimeList[i].startTotalMinutes < filterEndMinutes && spanTimeList[i].endTotalMinutes > filterStartMinutes) {
      newList.push(spanTimeList[i])
    }
  }
  return newList
}

export const base64ToBlob = (dataurl, filename) => {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]/* 文件类型 */
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

// 查询有没有人脸信息
export const queryFaceInfo = (paraUserid) => {
  return new Promise(function (resolve, reject) {
    var para = {
      user_id: paraUserid
    }
    api
      .axiosRequest(
        api.urlList.queryFace,
        para,
        null,
        true
      )
      .then(res => {
        console.log('查询人脸信息', res)
        if (res && res.code === common.resCode.OK) {
          // const msgBadge = res.total === 0 ? null : res.total
          if (res.list.length === 0) {
            resolve(null)
          } else {
            resolve(res.list[0])
          }
        } else {
          resolve(null)
        }
      })
      .catch(e => {
        reject(e)
      })
  })
}

//
export const getTeamGroup = (id) => {
  return new Promise(function (resolve, reject) {
    var para = {
      page_no: 1,
      page_size: 999,
      pid: id
    }
    api
      .axiosRequest(
        api.urlList.queryTeamGroupOrClass,
        para,
        null,
        true
      )
      .then(res => {
        console.log('查询班组信息', res)
        if (res.code === common.resCode.OK) {
          // const msgBadge = res.total === 0 ? null : res.total
          if (res.list.length === 0) {
            resolve(null)
          } else {
            resolve(res.list)
          }
        } else {
          resolve(null)
        }
      })
  })
}
export const getTeamGroupType = () => {
  return new Promise(function (resolve, reject) {
    var para = {

    }
    api
      .axiosRequest(
        api.urlList.queryTeamGroupTypeOrGrade,
        para,
        null,
        true
      )
      .then(res => {
        console.log('查询班组类型信息', res)
        if (res.code === common.resCode.OK) {
          // const msgBadge = res.total === 0 ? null : res.total
          if (res.list.length === 0) {
            resolve(null)
          } else {
            resolve(res.list)
          }
        } else {
          resolve(null)
        }
      })
  })
}
export const getOrganization = () => {
  return new Promise(function (resolve, reject) {
    var para = {
      pid: 0
    }
    api
      .axiosRequest(
        api.urlList.queryOrganization,
        para,
        null,
        true
      )
      .then(res => {
        console.log('查询组织信息', res)
        if (res.code === common.resCode.OK) {
          // const msgBadge = res.total === 0 ? null : res.total
          if (res.tree.length === 0) {
            resolve(null)
          } else {
            resolve(res.tree)
          }
        } else {
          resolve(null)
        }
      })
  })
}
export const getCurrentPosition = () => {
  return new Promise(function (resolve, reject) {
    const setting = localStorage.getItem(common.keyConfigInfo)
    let phoneSignInFlag = 0
    if (setting) {
      const configData = JSON.parse(setting)
      phoneSignInFlag = configData.phone_coordinate_sign_in
    }
    // 获取当前位置
    const currentPosition = {
      browserSupport: false, // 默认浏览器不支持获取地理位置
      phoneSignInFlag,
      currentLongitude: null,
      currentLatitude: null,
      geolocation: 'wgs84'
    }
    if (phoneSignInFlag) {
      if (navigator.geolocation) {
        currentPosition.browserSupport = true
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log('position', position)
            if (position && position.coords) {
              currentPosition.currentLongitude = position.coords.longitude
              currentPosition.currentLatitude = position.coords.latitude
              resolve(currentPosition)
            } else {
              reject(new Error('坐标获取失败'))
            }
          },
          (error) => {
            console.error(error)
            reject(error)
          }
        )
      } else {
        console.error('Geolocation is not supported by this browser.')
        reject(new Error('不支持地理坐标获取'))
      }
    } else {
      resolve(currentPosition)
    }
  })
}
